import { api } from '@/service/api'

const DEFAULT_ICON = 'stype-chuanganqi'
const storageKey = (projectId) => `alarm_hub_stypes_${projectId}`

let fetchedProjectId = ''

function snHex(sn = '') {
  const clean = String(sn || '').replace(/^TW-/i, '').toUpperCase()
  return clean.length >= 3 ? clean.slice(0, 3) : ''
}

function toNoHex(no) {
  const n = Number(no)
  if (!Number.isFinite(n)) return ''
  return n.toString(16).toUpperCase().padStart(3, '0')
}

function readCache(projectId) {
  try {
    const list = JSON.parse(localStorage.getItem(storageKey(projectId)) || 'null')
    return Array.isArray(list) ? list : []
  } catch {
    return []
  }
}

function applyList(list = []) {
  window.$store.projectStypes = list
}

export function getStypeIconClass(pic = '') {
  const value = String(pic || '').trim()
  if (!value) return DEFAULT_ICON
  const icon = value.startsWith('stype-') ? value : `stype-${value}`
  return /^stype-[A-Za-z0-9_-]+$/.test(icon) ? icon : DEFAULT_ICON
}

export function findStypeBySn(sn) {
  const hex = snHex(sn)
  if (!hex) return null
  const list = window.$store?.projectStypes || []
  return list.find((s) => toNoHex(s.no) === hex) || null
}

/** 按 model / name 匹配项目内设备类型 */
export function findStypeByModel(model) {
  const key = String(model || '').trim().toLowerCase()
  if (!key) return null
  const list = window.$store?.projectStypes || []
  return (
    list.find((s) => {
      const modelVal = String(s.model || '').trim().toLowerCase()
      const nameVal = String(s.name || '').trim().toLowerCase()
      return modelVal === key || nameVal === key
    }) || null
  )
}

export function getStypeIconBySn(sn) {
  return getStypeIconClass(findStypeBySn(sn)?.pic)
}

/** 首次进入项目拉取 stype 并写入本地缓存；同项目后续直接复用 */
export async function fetchProjectStypes() {
  const projectId = window.$store?.currentProject?.id
  if (!projectId) return []

  if (fetchedProjectId !== projectId) {
    applyList(readCache(projectId))
  }

  if (fetchedProjectId === projectId && window.$store.projectStypes?.length) {
    return window.$store.projectStypes
  }

  const res = await api('sensor', 'get_project_stypes', { project_id: projectId })
  if (res.code === 200 && Array.isArray(res.data)) {
    applyList(res.data)
    localStorage.setItem(storageKey(projectId), JSON.stringify(res.data))
  }
  fetchedProjectId = projectId
  return window.$store.projectStypes || []
}
